var _style, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _polygon, _g, _line, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _line2, _rect, _polygon3, _polygon4, _line3, _polyline, _rect2, _circle, _rect3, _circle2, _rect4, _circle3, _rect5, _circle4, _rect6, _circle5, _rect7, _circle6, _ellipse2, _rect8, _ellipse3, _rect9, _ellipse4, _rect10, _ellipse5, _rect11, _ellipse6, _rect12, _ellipse7, _rect13, _line4, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfsleeve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st354{fill:#FFFFFF;stroke:#282716;stroke-width:2;stroke-miterlimit:10;}\n\t.st353{fill:#FFFFFF;stroke:#282716;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.26;}\n\t.st352{fill:#FFFFFF;stroke:#282716;stroke-width:2.18;stroke-miterlimit:10;}\n\t.st351{fill:#FFFFFF;stroke:#282716;stroke-width:0.32;stroke-miterlimit:10;stroke-dasharray:1.26;}\n\t.st350{fill:#FFFFFF;}\n\t.st349{fill:none;stroke:#282716;stroke-width:2;stroke-miterlimit:10;}\n\t.st348{fill:none;stroke:#282716;stroke-width:1.26;stroke-miterlimit:10;}\n\t.st347{fill:none;stroke:#282716;stroke-width:0.32;stroke-miterlimit:10;stroke-dasharray:1.26,1.26;}\n\t.st346{fill:none;stroke:#282716;stroke-width:0.95;stroke-miterlimit:10;}\n\t.st345{fill:none;stroke:#282716;stroke-width:0.32;stroke-miterlimit:10;stroke-dasharray:1.26;}\n\t.st344{fill:#FFFFFF;stroke:#282716;stroke-width:0.95;stroke-miterlimit:10;}\n\t.st343{fill:#010101;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st354",
    d: "M344.1,232.3l-40.2,35.3L267,231.8l40.3-75.2C308,157.7,332.6,208.5,344.1,232.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st354",
    d: "M349.9,244.4l-37.7,31.3l-8.3-8.2l40.2-35.3L349.9,244.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st353",
    d: "M306.8,267.7l36.6-32.1l4,8.3l-35.2,29.2L306.8,267.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st354",
    d: "M78.9,233.5l40.2,35.3L156,233l-40.3-75.2C115,158.8,90.4,209.7,78.9,233.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st354",
    d: "M73.1,245.6l37.7,31.3l8.3-8.1l-40.2-35.3C75.4,240.8,73.1,245.6,73.1,245.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st353",
    d: "M116.2,268.9l-36.6-32.2c-1.8,3.8-3.2,6.7-4,8.3l35.1,29.2L116.2,268.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st352",
    cx: 212.1,
    cy: 378.5,
    rx: 84.8,
    ry: 32.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st354",
    d: "M220.2,156.8l-0.8,34.6v214.1l-13.8-0.1l-16.2-0.7l-20.4-4l-21.4-7l-20.2-14.2l3-114.1l0.8-59.7l-5.3-23.4 l-8.4-20.2l0,0l0,0l-0.3-0.8l-1.4-3.4l8.2-8.1l26.5-14.7c0,0,13-5.4,20.7-8.5l0.8-0.3c2.4-1.1,4.3-1.8,4.4-1.8l4.9,2.9l0.9,0.5 L204,141l2,1.2l4.7,2.8l0.3,0.2l1.2,0.7l1.1,0.7l2.2,1.3l4,2.3l0.6,4.8l0.1,0.9L220.2,156.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st351",
    points: "120,163 182.6,128.6 183.5,130.1 120.9,164.5 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PALLA"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M245.4,126.5c2.1-1.1,4.5-1.3,6.8-0.5l19.1,7.7c1.9,0.8,5,2.3,6.8,3.3l19.9,11.1c2.2,1.3,4.2,2.8,6,4.5 l2.8,2.8c1.5,1.6,2,4,1.2,6.1l-7.3,17.4c-0.9,2.3-1.7,4.7-2.3,7.2l-3.6,16c-0.5,2.5-0.8,5-0.8,7.5l0.7,52.1c0,2.1,0.1,5.5,0.1,7.6 l2.8,106.5c-0.1,2.3-1.2,4.5-3,6l-14,9.8c-2.1,1.4-4.3,2.5-6.7,3.4l-14.2,4.7c-2.4,0.8-4.8,1.4-7.3,1.9l-13,2.5 c-2.5,0.4-5,0.7-7.5,0.9l-22.5,1c-2,0.1-3.7-1.4-3.8-3.4c0-0.1,0-0.2,0-0.2v-207c0-2.1,0-5.5-0.1-7.6l-0.6-27 c0-2.4,0.1-4.8,0.3-7.1c0.5-2.2,1.8-4.1,3.6-5.3L245.4,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st349",
    d: "M245.4,126.5c2.1-1.1,4.5-1.3,6.8-0.5l19.1,7.7c1.9,0.8,5,2.3,6.8,3.3l19.9,11.1c2.2,1.3,4.2,2.8,6,4.5 l2.8,2.8c1.5,1.6,2,4,1.2,6.1l-7.3,17.4c-0.9,2.3-1.7,4.7-2.3,7.2l-3.6,16c-0.5,2.5-0.8,5-0.8,7.5l0.7,52.1c0,2.1,0.1,5.5,0.1,7.6 l2.8,106.5c-0.1,2.3-1.2,4.5-3,6l-14,9.8c-2.1,1.4-4.3,2.5-6.7,3.4l-14.2,4.7c-2.4,0.8-4.8,1.4-7.3,1.9l-13,2.5 c-2.5,0.4-5,0.7-7.5,0.9l-22.5,1c-2,0.1-3.7-1.4-3.8-3.4c0-0.1,0-0.2,0-0.2v-207c0-2.1,0-5.5-0.1-7.6l-0.6-27 c0-2.4,0.1-4.8,0.3-7.1c0.5-2.2,1.8-4.1,3.6-5.3L245.4,126.5z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st348",
    x1: 244.6,
    y1: 130.2,
    x2: 308,
    y2: 167
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st351",
    points: "239.8,131.5 240.6,129.8 304.5,165.8 303.7,167.5 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M237,108.7c0.9,0,1.6,0.7,1.6,1.6v10.5c0,0.9-0.7,1.6-1.6,1.6c0,0,0,0,0,0h-51.6c-0.9,0-1.6-0.7-1.6-1.6v-10.5 c0-0.9,0.7-1.6,1.6-1.6H237z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st348",
    d: "M237,108.7c0.9,0,1.6,0.7,1.6,1.6v10.5c0,0.9-0.7,1.6-1.6,1.6c0,0,0,0,0,0h-51.6c-0.9,0-1.6-0.7-1.6-1.6v-10.5 c0-0.9,0.7-1.6,1.6-1.6H237z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M186.2,121.6c-0.9,0-1.6-0.7-1.6-1.6v-8.8c0-0.9,0.7-1.6,1.6-1.6h49.9c0.9,0,1.6,0.7,1.6,1.6v8.8 c0,0.9-0.7,1.6-1.6,1.6H186.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st347",
    d: "M186.2,121.6c-0.9,0-1.6-0.7-1.6-1.6v-8.8c0-0.9,0.7-1.6,1.6-1.6h49.9c0.9,0,1.6,0.7,1.6,1.6v8.8 c0,0.9-0.7,1.6-1.6,1.6H186.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M217.3,150.5c0.3,1,0.5,2.1,0.5,3.1v0.6c0,0.9-0.7,1.6-1.6,1.6c0,0,0,0,0,0h-4.4c-0.9,0-2.3-0.1-3.2-0.2 l-1.9-0.2c-0.9-0.1-1.6-0.2-1.7-0.2c-0.1,0-0.3,0-0.4-0.1l-1.9-0.3l-3.8-0.6c-0.9-0.2-1.8-0.5-2.5-1c-0.5-0.4-1.1-0.9-1.3-1 l-0.4-0.3c-0.1,0-0.3-0.4-0.6-0.8s0-1.2,0.6-1.8l7.8-7.1c0.7-0.6,1.7-0.7,2.5-0.2l0,0l1.5,1c0.2,0.1,0.4,0.1,0.6,0.1 c0.2,0,1.2,0.2,2.1,0.3h0.2c0.9,0.1,1.7,0.3,1.9,0.3l0.7,0.1c0.3,0.1,0.5,0.2,0.8,0.3l0.7,0.6c0.2,0.2,0.8,0.6,1.3,1l1.3,1 c0.4,0.5,0.7,1.2,0.9,1.8L217.3,150.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st346",
    d: "M217.3,150.5c0.3,1,0.5,2.1,0.5,3.1v0.6c0,0.9-0.7,1.6-1.6,1.6c0,0,0,0,0,0h-4.4c-0.9,0-2.3-0.1-3.2-0.2 l-1.9-0.2c-0.9-0.1-1.6-0.2-1.7-0.2c-0.1,0-0.3,0-0.4-0.1l-1.9-0.3l-3.8-0.6c-0.9-0.2-1.8-0.5-2.5-1c-0.5-0.4-1.1-0.9-1.3-1 l-0.4-0.3c-0.1,0-0.3-0.4-0.6-0.8s0-1.2,0.6-1.8l7.8-7.1c0.7-0.6,1.7-0.7,2.5-0.2l0,0l1.5,1c0.2,0.1,0.4,0.1,0.6,0.1 c0.2,0,1.2,0.2,2.1,0.3h0.2c0.9,0.1,1.7,0.3,1.9,0.3l0.7,0.1c0.3,0.1,0.5,0.2,0.8,0.3l0.7,0.6c0.2,0.2,0.8,0.6,1.3,1l1.3,1 c0.4,0.5,0.7,1.2,0.9,1.8L217.3,150.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M211.8,155c-1.1,0-2.2-0.1-3.2-0.2l-2.8-0.3c-0.9-0.1-2.3-0.3-3.2-0.4l-3.5-0.5c-1-0.2-2-0.6-2.9-1.2l0,0 c-0.5-0.4-1-0.8-1.5-1.3c-0.1-0.2,0.3-0.8,0.9-1.4l6.7-6.1c0.7-0.6,1.7-0.7,2.4-0.2c0.9,0.5,1.8,0.9,2.9,1.1l2.6,0.4 c1,0.2,2,0.6,2.9,1.3l1.1,0.9c0.8,0.7,1.4,1.5,1.8,2.5l0.4,1.1c0.3,0.9,0.5,1.9,0.5,2.9c-0.1,0.8-0.8,1.5-1.6,1.4L211.8,155 L211.8,155z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st347",
    d: "M211.8,155c-3.1-0.1-6.1-0.4-9.1-0.9c-1.9-0.3-4.9-0.5-6.4-1.8c-0.5-0.4-1-0.8-1.5-1.3 c-0.1-0.2,0.3-0.8,0.9-1.4l6.7-6.1c0.7-0.6,1.7-0.7,2.5-0.2c1.4,1,3.8,1.3,5.4,1.6c1.5,0.3,2.9,1.1,4,2.1c1.1,1,1.9,2.3,2.2,3.7 c0.3,0.9,0.5,1.9,0.5,2.9c-0.1,0.8-0.8,1.5-1.6,1.4L211.8,155L211.8,155z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M228.2,149.5c0.6,0.6,0.9,1.4,0.6,1.8s-0.6,0.7-0.6,0.7l-0.4,0.3c-0.2,0.1-0.8,0.6-1.4,1 c-0.8,0.5-1.7,0.9-2.6,1l-2.2,0.3l-2.4,0.4l-1.2,0.2l-2,0.2l-2.1,0.2c-0.9,0.1-2.3,0.2-3.2,0.2h-4.4c-0.9,0-1.6-0.7-1.6-1.6v-0.6 c0-1.1,0.2-2.1,0.5-3.1l0.5-1.6c0.4-1,1-1.8,1.8-2.5l0.8-0.7l1.6-1.2c0.2-0.1,0.4-0.2,0.6-0.3c0.1,0,0.3,0,0.4-0.1s0.9-0.1,1.8-0.3 l1-0.2c0.9-0.1,1.8-0.3,2-0.3c0.2,0,0.4-0.1,0.6-0.2l1.5-1c0.7-0.5,1.4-0.8,1.6-0.7s0.8,0.7,1.4,1.3L228.2,149.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st346",
    d: "M228.2,149.5c0.6,0.6,0.9,1.4,0.6,1.8s-0.6,0.7-0.6,0.7l-0.4,0.3c-0.2,0.1-0.8,0.6-1.4,1 c-0.8,0.5-1.7,0.9-2.6,1l-2.2,0.3l-2.4,0.4l-1.2,0.2l-2,0.2l-2.1,0.2c-0.9,0.1-2.3,0.2-3.2,0.2h-4.4c-0.9,0-1.6-0.7-1.6-1.6v-0.6 c0-1.1,0.2-2.1,0.5-3.1l0.5-1.6c0.4-1,1-1.8,1.8-2.5l0.8-0.7l1.6-1.2c0.2-0.1,0.4-0.2,0.6-0.3c0.1,0,0.3,0,0.4-0.1s0.9-0.1,1.8-0.3 l1-0.2c0.9-0.1,1.8-0.3,2-0.3c0.2,0,0.4-0.1,0.6-0.2l1.5-1c0.7-0.5,1.4-0.8,1.6-0.7s0.8,0.7,1.4,1.3L228.2,149.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M207.4,155c-0.8,0.1-1.5-0.6-1.6-1.4c0-1,0.2-2,0.5-2.9l0.4-1.2c0.4-1,1-1.8,1.8-2.5l1.1-0.9 c0.9-0.6,1.8-1,2.9-1.3l2.6-0.4c1-0.2,2-0.6,2.9-1.1c0.8-0.5,1.8-0.4,2.4,0.2l6.7,6.1c0.6,0.6,1.1,1.2,0.9,1.4 c-0.5,0.5-1,0.9-1.5,1.3l0,0c-0.9,0.6-1.8,1-2.9,1.2l-3.6,0.6c-0.9,0.1-2.3,0.3-3.2,0.4l-2.7,0.3c-0.9,0.1-2.3,0.2-3.2,0.2 L207.4,155L207.4,155z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st347",
    d: "M207.4,155c-0.8,0.1-1.5-0.6-1.6-1.4c0.1-1.4,0.4-2.8,0.9-4.1c0.6-1.4,1.6-2.6,2.9-3.4c0.9-0.6,1.8-1,2.9-1.3 l2.6-0.4c1-0.2,2-0.6,2.9-1.1c0.8-0.5,1.8-0.4,2.4,0.2l6.7,6.1c0.6,0.6,1.1,1.2,0.9,1.4c-0.5,0.5-1,0.9-1.6,1.3 c-0.9,0.6-1.8,1-2.9,1.2l-3.6,0.6c-1.7,0.3-4.1,0.5-5.9,0.7S209.3,155,207.4,155L207.4,155z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M251.3,123.6c0.5,0.7,0.9,1.5,0.8,1.7s-0.6,1.1-0.9,1.9l-0.9,1.8c-0.4,0.8-0.8,1.6-0.9,1.8s-0.3,0.6-0.4,0.8 s-0.5,1-0.9,1.8l-0.2,0.4c-0.4,0.8-1.1,2.1-1.4,2.9l-5,10.4c-0.4,0.8-1.1,2.1-1.5,2.8l-5,8.5c-0.3,0.5-0.9,0.8-1.5,0.5 c-0.2-0.1-0.3-0.2-0.4-0.3l-4.3-4.9c-0.6-0.7-1.2-1.4-1.4-1.6l-1.3-1.6l-0.2-0.2c-0.7-0.8-1.5-1.5-2.4-2.1l-5.4-3.4 c-0.7-0.5-1.5-0.9-1.6-1l-0.6-0.4l-0.5-0.3c0.2-0.5,0.5-0.9,0.9-1.4l13.6-18.2c0.5-0.7,1.1-1.4,1.2-1.6c0.1-0.1,0.2-0.3,0.3-0.4 c0-0.1,0.5-0.8,0.9-1.5l4.7-8.1c0.4-0.8,1-1.7,1.3-2.2s0.5-0.9,0.6-1s0.6,0.3,1.3,0.9l2,2c0.6,0.6,1.6,1.7,2.1,2.4L251.3,123.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st348",
    d: "M251.3,123.6c0.5,0.7,0.9,1.5,0.8,1.7s-0.6,1.1-0.9,1.9l-0.9,1.8c-0.4,0.8-0.8,1.6-0.9,1.8s-0.3,0.6-0.4,0.8 s-0.5,1-0.9,1.8l-0.2,0.4c-0.4,0.8-1.1,2.1-1.4,2.9l-5,10.4c-0.4,0.8-1.1,2.1-1.5,2.8l-5,8.5c-0.3,0.5-0.9,0.8-1.5,0.5 c-0.2-0.1-0.3-0.2-0.4-0.3l-4.3-4.9c-0.6-0.7-1.2-1.4-1.4-1.6l-1.3-1.6l-0.2-0.2c-0.7-0.8-1.5-1.5-2.4-2.1l-5.4-3.4 c-0.7-0.5-1.5-0.9-1.6-1l-0.6-0.4l-0.5-0.3c0.2-0.5,0.5-0.9,0.9-1.4l13.6-18.2c0.5-0.7,1.1-1.4,1.2-1.6c0.1-0.1,0.2-0.3,0.3-0.4 c0-0.1,0.5-0.8,0.9-1.5l4.7-8.1c0.4-0.8,1-1.7,1.3-2.2s0.5-0.9,0.6-1s0.6,0.3,1.3,0.9l2,2c0.6,0.6,1.6,1.7,2.1,2.4L251.3,123.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M226.3,149.8c-0.7-0.8-1.5-1.5-2.4-2.1l-6-3.8c-0.7-0.4-0.9-1.3-0.5-2c0,0,0.1-0.1,0.1-0.1l13.5-18.1 c0.6-0.9,1.2-1.8,1.8-2.7l5.5-9.4c0.3-0.6,1-0.8,1.6-0.5c0.1,0.1,0.3,0.2,0.4,0.3l1.1,1.2c0.6,0.6,1.6,1.7,2.1,2.4l6.8,8.8 c0.5,0.8,0.6,1.8,0.2,2.7l-3.6,7c-0.4,0.8-1,2.1-1.4,2.9l-5,10.5c-0.4,0.8-1.1,2.1-1.5,2.8l-4.4,7.4c-0.2,0.5-0.9,0.8-1.4,0.5 c-0.2-0.1-0.3-0.2-0.4-0.4L226.3,149.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st347",
    d: "M226.3,149.8c-1.4-1.8-6.6-4.6-8.4-5.9c-0.7-0.4-0.9-1.3-0.5-2c0,0,0.1-0.1,0.1-0.1 c1.2-1.7,14.8-19.5,15.3-20.8l5.5-9.4c0.3-0.6,1-0.8,1.5-0.5c0.1,0.1,0.3,0.2,0.4,0.3l1.1,1.2c0.6,0.6,1.6,1.7,2.1,2.4l6.8,8.8 c0.6,0.8,0.6,1.8,0.2,2.7c-2.9,5.5-7.3,14.7-10,20.4c-0.9,2.1-4.7,8.2-5.9,10.2c-0.3,0.5-0.9,0.8-1.5,0.5c-0.2-0.1-0.3-0.2-0.4-0.4 L226.3,149.8L226.3,149.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M216.2,142c-0.4,0.4-0.6,0.9-0.9,1.4c-0.5,0.2-1,0.3-1.5,0.3l-0.9,0.2c-0.6,0.1-1.3,0.2-1.9,0.2 c-0.6-0.2-1.1-0.5-1.7-0.9l-1.9-1.1c-0.9-0.6-1.7-1.3-2.4-2.1L193,123.8c-0.5-0.7-0.2-1.3,0.6-1.3h35.6c0.9,0,1.2,0.6,0.6,1.3 L216.2,142z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st346",
    d: "M216.2,142c-0.4,0.4-0.6,0.9-0.9,1.4c-0.5,0.2-1,0.3-1.5,0.3l-0.9,0.2c-0.6,0.1-1.3,0.2-1.9,0.2 c-0.6-0.2-1.1-0.5-1.7-0.9l-1.9-1.1c-0.9-0.6-1.7-1.3-2.4-2.1L193,123.8c-0.5-0.7-0.2-1.3,0.6-1.3h35.6c0.9,0,1.2,0.6,0.6,1.3 L216.2,142z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st346",
    x1: 215.2,
    y1: 155.6,
    x2: 217.8,
    y2: 405.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 157.4,
    className: "st345",
    width: 6.8,
    height: 248.6
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st344",
    points: "228.8,200.7 275.8,200.7 275.8,239.1 255.9,247.8 231.3,240.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st351",
    points: "232.2,240 229.7,201.6 274.9,201.6 274.9,238.5 255.9,246.9 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st345",
    x1: 229.4,
    y1: 209.1,
    x2: 275.8,
    y2: 208
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st345",
    points: "127.5,375.5 148.2,389.9 163.1,395.4 174.3,398.5 185.8,400.4 198.2,401.8 204.9,401.8 205.7,403.3  213.2,403.3 217.8,402.7 226.4,402.7 240.7,400.8 255.6,397.7 269.6,393.3 279.9,388.3 289.6,382.1 297.7,376.4 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210.1,
    y: 149.8,
    transform: "matrix(0.993 -0.1182 0.1182 0.993 -16.2597 26.1575)",
    className: "st350",
    width: 4.4,
    height: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st350",
    cx: 211.6,
    cy: 150.2,
    r: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 169.1,
    className: "st350",
    width: 0.6,
    height: 4.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st350",
    cx: 211.4,
    cy: 172,
    r: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 359.5,
    className: "st350",
    width: 0.6,
    height: 4.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st350",
    cx: 211.4,
    cy: 362.4,
    r: 2.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 211.3,
    y: 310.3,
    className: "st350",
    width: 0.6,
    height: 4.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st350",
    cx: 211.6,
    cy: 313.2,
    r: 2.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 258.4,
    className: "st350",
    width: 0.6,
    height: 4.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st350",
    cx: 211.3,
    cy: 261.4,
    r: 2.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 212.5,
    className: "st350",
    width: 0.6,
    height: 4.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st350",
    cx: 211.3,
    cy: 215.4,
    r: 2.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9384 -0.3456 0.3456 0.9384 -39.1126 82.3593)",
    className: "st343",
    cx: 211.4,
    cy: 150.9,
    rx: 2.2,
    ry: 2.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 208.9,
    y: 150.6,
    transform: "matrix(0.9384 -0.3456 0.3456 0.9384 -39.081 82.4278)",
    className: "st343",
    width: 5.4,
    height: 0.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st343",
    cx: 211.4,
    cy: 177.6,
    rx: 2.3,
    ry: 2.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 211.2,
    y: 174.6,
    className: "st343",
    width: 0.5,
    height: 5.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st343",
    cx: 211.1,
    cy: 218.4,
    rx: 2.3,
    ry: 2.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210.9,
    y: 215.4,
    className: "st343",
    width: 0.5,
    height: 5.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st343",
    cx: 211.1,
    cy: 263,
    rx: 2.3,
    ry: 2.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 210.9,
    y: 260.1,
    className: "st343",
    width: 0.5,
    height: 5.4
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st343",
    cx: 211.6,
    cy: 303.8,
    rx: 2.3,
    ry: 2.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 300.9,
    className: "st343",
    width: 0.5,
    height: 5.4
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st343",
    cx: 211.6,
    cy: 342.6,
    rx: 2.3,
    ry: 2.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 339.6,
    className: "st343",
    width: 0.5,
    height: 5.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st348",
    x1: 182.5,
    y1: 127.7,
    x2: 118.6,
    y2: 163.8
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M206.8,142.3c0.3,0.3,0.5,0.7,0.6,1.1l-0.7,0.4c-0.3,0.2-1.2,0.8-1.9,1.2l-5.3,3.4c-0.9,0.6-1.7,1.3-2.4,2.1 l-0.2,0.3l-1.4,1.6l-1.4,1.6l-4.2,4.8c-0.4,0.5-1,0.6-1.5,0.2c-0.1-0.1-0.3-0.2-0.3-0.4l-5-8.5c-0.4-0.8-1.1-2-1.5-2.8l-5-10.4 c-0.4-0.8-1-2.1-1.4-2.9l-0.1-0.1c-0.4-0.8-0.8-1.6-0.9-1.8l-0.4-0.8l-0.9-1.8l-1-2c-0.4-0.8-0.8-1.6-1-1.9s0.2-1,0.8-1.7l7.1-9.2 c0.6-0.7,1.5-1.8,2.1-2.4l1.8-1.8l1.2-1.3c0.1,0,0.2,0.2,0.4,0.5s0.7,1.2,1.1,2l5.2,8.9c0.4,0.8,0.8,1.5,0.9,1.5l0.3,0.4l1.2,1.6 l12.1,16.2C205.6,140.7,206.4,141.7,206.8,142.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st348",
    d: "M206.8,142.3c0.3,0.3,0.5,0.7,0.6,1.1l-0.7,0.4c-0.3,0.2-1.2,0.8-1.9,1.2l-5.3,3.4c-0.9,0.6-1.7,1.3-2.4,2.1 l-0.2,0.3l-1.4,1.6l-1.4,1.6l-4.2,4.8c-0.4,0.5-1,0.6-1.5,0.2c-0.1-0.1-0.3-0.2-0.3-0.4l-5-8.5c-0.4-0.8-1.1-2-1.5-2.8l-5-10.4 c-0.4-0.8-1-2.1-1.4-2.9l-0.1-0.1c-0.4-0.8-0.8-1.6-0.9-1.8l-0.4-0.8l-0.9-1.8l-1-2c-0.4-0.8-0.8-1.6-1-1.9s0.2-1,0.8-1.7l7.1-9.2 c0.6-0.7,1.5-1.8,2.1-2.4l1.8-1.8l1.2-1.3c0.1,0,0.2,0.2,0.4,0.5s0.7,1.2,1.1,2l5.2,8.9c0.4,0.8,0.8,1.5,0.9,1.5l0.3,0.4l1.2,1.6 l12.1,16.2C205.6,140.7,206.4,141.7,206.8,142.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M183.8,149.5c-0.4-0.8-1.1-2-1.5-2.8l-5-10.4c-0.4-0.8-1-2.1-1.4-2.9l-3.6-7.1c-0.4-0.9-0.3-1.9,0.2-2.7 l6.8-8.8c0.5-0.7,1.5-1.8,2.1-2.4l1.1-1.1c0.4-0.5,1.1-0.6,1.6-0.1c0.1,0.1,0.2,0.2,0.3,0.4l5.5,9.4c0.4,0.8,1.2,2,1.8,2.7 l13.6,18.1c0.5,0.6,0.4,1.6-0.3,2c0,0-0.1,0.1-0.1,0.1l-6,3.8c-0.9,0.6-1.7,1.3-2.4,2.1l-6.4,7.4c-0.4,0.5-1,0.6-1.5,0.2 c-0.1-0.1-0.3-0.2-0.3-0.4L183.8,149.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st347",
    d: "M183.8,149.5c-1.1-1.8-5.4-11.1-6.5-13.2s-3.9-7.9-5-9.9c-0.4-0.9-0.3-1.9,0.2-2.7c2.1-2.7,7.6-10.1,10-12.3 c0.4-0.5,1.2-0.5,1.7-0.1c0.1,0.1,0.2,0.2,0.3,0.4c1.3,2.1,5.8,10.3,7.3,12.1l13.6,18.1c0.5,0.6,0.4,1.6-0.3,2.1 c0,0-0.1,0.1-0.1,0.1l-6,3.8c-2,1.1-7.2,7.7-8.8,9.4c-0.3,0.5-1,0.6-1.5,0.3c-0.1-0.1-0.3-0.2-0.3-0.4L183.8,149.5L183.8,149.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfsleeve);
export default __webpack_public_path__ + "static/media/HALF SLEEVE.c732840cfdb763693a7172b8dfceed6a.svg";
export { ForwardRef as ReactComponent };